<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P00076.installation.consommation.title' | translate"
      [description]="'P00076.installation.consommation.description' | translate"
    >
    </app-header-configuration>

    @if (currentForm) {
      <form [formGroup]="currentForm">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <app-information-title
                [title]="'P00076.installation.consommation.surface' | translate"
              ></app-information-title>

              <div class="position-relative">
                <ion-input
                  [placeholder]="'' | translate"
                  formControlName="surface"
                  mode="ios"
                  (ionBlur)="onSurfaceBlur($event)"
                ></ion-input>
              </div>
            </div>
          </div>
        </div>
      </form>
    }
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button
        color="primary"
        expand="block"
        (click)="onSubmit()"
        [disabled]="!currentForm?.valid"
      >
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
